import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import React from "react";
interface ICollegeCourse {
  gender: string;
  caste: string;
  counsellingName: string;
  courseTitle: string;
  lastYearCutoffAiRank: number;
  openingRank: number;
  closingRank: number;
  courseName: string;
  collegeId: number;
  fee: string;
  seats: number;
  year: string;
}
interface ICollege {
  cityName: string;
  stateName: string;
  collegeName: string;
  ownerShip: string;
  collegeId: number;
  collegeTitle: string;
  courseVo: ICollegeCourse[];
}

interface ReportDownloadProps {
  filteredColleges: ICollege[];
}

const ReportDownload: React.FC<ReportDownloadProps> = ({
  filteredColleges,
}) => {
  const handleSaveList = () => {
    const doc = new jsPDF("p", "pt", "a4");

    doc.setFontSize(14);
    doc.text("Predicted College List Report", 40, 30);

    const tableColumn = [
      { header: "College Name", dataKey: "collegeName" },
      { header: "Course Title", dataKey: "courseTitle" },
      { header: "Ownership", dataKey: "ownerShip" },
      { header: "City", dataKey: "cityName" },
      { header: "State", dataKey: "stateName" },
      { header: "Opening Rank", dataKey: "openingRank" },
      { header: "Closing Rank", dataKey: "closingRank" },
      { header: "Fee", dataKey: "fee" },
      { header: "Seats", dataKey: "seats" },
      { header: "Caste", dataKey: "caste" },
      { header: "Gender", dataKey: "gender" },
      { header: "Year", dataKey: "year" },
    ];

    const tableRows = filteredColleges.flatMap((college) =>
      college.courseVo.map((course) => ({
        collegeName: college.collegeName,
        courseTitle: course.courseTitle,
        ownerShip: college.ownerShip,
        cityName: college.cityName,
        stateName: college.stateName,
        openingRank: course.openingRank,
        closingRank: course.closingRank,
        fee: course.fee,
        seats: course.seats,
        caste: course.caste,
        gender: course.gender,
        year: course.year,
      }))
    );

    autoTable(doc, {
      columns: tableColumn,
      body: tableRows,
      startY: 40,
      styles: {
        fontSize: 8,
        cellPadding: 4,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        halign: "center",
      },
      bodyStyles: {
        halign: "left",
        valign: "top",
      },
      didDrawPage: () => {
        doc.setFontSize(10);
        doc.text(
          "Generated by MentorMentee Predictor",
          40,
          doc.internal.pageSize.height - 20
        );

        const pageNumber = doc.getCurrentPageInfo().pageNumber;
        const totalPages = doc.getNumberOfPages();
        doc.text(
          `Page ${pageNumber} of ${totalPages}`,
          doc.internal.pageSize.width - 100,
          doc.internal.pageSize.height - 20
        );
      },
    });

    doc.save("Predicted_Colleges_List.pdf");
  };

  return (
    <div className="flex justify-center w-full">
      <div className="w-full flex flex-wrap">
        <div className="flex py-2 item-center max-xs:justify-center max-xs:w-full w-[80%] bg-[#173CBA] text-white text-[16px] pl-4 pt-1">
          Get Personalised Report in PDF
        </div>
        <button
          onClick={handleSaveList}
          className="flex item-center py-2 justify-center ax-xs:text-center max-xs:w-full w-[20%] bg-[#0C9] pt-1 text-white text-[16px] px-4 text-center cursor-pointer"
        >
          Download
        </button>
      </div>
    </div>
  );
};

export default ReportDownload;
